import { render, staticRenderFns } from "./SelectBookScrollMenu.vue?vue&type=template&id=243f10b8&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeFavorite/components/SelectBookScrollMenu.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeFavorite/components/SelectBookScrollMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports